import * as React from "react";
import { ThemeProvider } from "@mui/material/styles";
import lightTheme from "../themes/light";
import darkTheme from "../themes/dark";

interface ThemeProps {
  isDark?: boolean;
  children?: React.ReactNode;
}
export const VaporThemeProvider: React.FC<{}> = (props: ThemeProps) => {
  return (
    <ThemeProvider theme={props.isDark ? darkTheme : lightTheme}>
      {props.children}
    </ThemeProvider>
  );
};
